import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Employee } from "../../components/Employees/types/employees";

export interface EmployeeState {
  employeeList: Employee[];
  employeeDetail?: Employee;
}

export const initialEmployeeState: EmployeeState = {
  employeeList: []
};

export const employeeSlice = createSlice({
  name: "employees",
  initialState: initialEmployeeState,
  reducers: {
    setEmployeeList: (state, action: PayloadAction<Employee[]>) => {
      state.employeeList = action.payload;
    },

    resetEmployeeList: (state) => {
      state.employeeList = initialEmployeeState.employeeList;
    },

    // pagination append
    addEmployeeList: (state, action: PayloadAction<Employee[]>) => {
      state.employeeList = [...state.employeeList, ...action.payload];
    },

    setEmployeeDetail: (state, action: PayloadAction<Employee>) => {
      state.employeeDetail = action.payload;
    },

    resetEmployeeDetail: (state) => {
      state.employeeDetail = initialEmployeeState.employeeDetail;
    }
  }
});

// actions
export const {
  setEmployeeList,
  setEmployeeDetail,
  resetEmployeeList,
  addEmployeeList,
  resetEmployeeDetail
} = employeeSlice.actions;

export default employeeSlice.reducer;
